<template>
  <div class="big-customer-setting public_Spacing">
    <div class="setting-panel setting-hero">
      <div>
        <div class="setting-section-title">大客户设置</div>
        <div class="setting-section-desc">
          给指定用户统一配置下单冻结、油卡比例、授权厂家；每次提交都会生成设置记录，可按用户名随时检索。
        </div>
      </div>
        <el-button id="用户设置" v-shiroHiden="solelist" type="primary" icon="el-icon-setting" @click="openSettingPanel">用户设置</el-button>
    </div>

    <div class="setting-panel">
      <div class="setting-section-title">记录检索</div>
      <div class="setting-filter-row">
        <div class="setting-filter-item">
          <label>用户名：</label>
          <el-select
            v-model="query.ORMTB410ID"
            filterable
            remote
            clearable
            :remote-method="filterCustomer"
            placeholder="请选择用户名"
            @change="handleQueryCustomerChange">
            <el-option
              v-for="item in queryCustomerOptions"
              :key="item.ORMTB410ID"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410ID">
            </el-option>
          </el-select>
        </div>
        <div class="setting-filter-item">
          <label>设置类型：</label>
          <el-select v-model="query.settingType" clearable placeholder="全部类型">
            <el-option
              v-for="item in settingTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button type="info" plain @click="resetQuery">重置</el-button>
        <div class="setting-action-tip">
          <el-button
            id="查看用户当前设置"
            v-shiroHiden="solelist"
            type="primary"
            icon="el-icon-view"
            :disabled="!query.ORMTB410ID"
            @click="viewSelectedUserSetting">
            查看用户当前设置
          </el-button>
          <span class="setting-inline-tip">选择用户名后，可查看当前用户当前生效的设置项。</span>
        </div>
      </div>
    </div>

    <div class="setting-panel setting-table">
      <div class="setting-table-head">
        <div>
          <div class="setting-section-title">设置记录</div>
          <div class="setting-section-desc">
            查看某个用户曾经配置过哪些设置，以及每次提交后的设置内容。
          </div>
        </div>
      </div>
      <el-table
        :data="tableData"
        stripe
        class="public_tableColumn setting-record-table"
        empty-text="暂无设置记录"
        v-loading="tableLoading">
        <el-table-column
          prop="ORMTB410CA00"
          label="用户名"
          min-width="96"
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column
          prop="settingType"
          label="设置类型"
          min-width="110"
          show-overflow-tooltip
          align="center">
          <template slot-scope="scope">{{ formatSettingType(scope.row.settingType) }}</template>
        </el-table-column>
        <el-table-column
          prop="createName"
          label="操作人"
          min-width="88"
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="设置时间"
          min-width="148"
          show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column label="操作" min-width="88" align="center">
          <template slot-scope="scope">
            <el-button id="详情" v-shiroHiden="solelist" type="text" @click="viewDetailSetting(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="setting-pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="用户设置面板"
      :visible.sync="dialogVisible"
      width="860px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="big-customer-setting-dialog">
      <el-form ref="settingForm" :model="form" :rules="rules" label-width="110px">
        <div class="setting-block">
          <div class="setting-block-title">设置对象</div>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="用户" prop="ORMTB410ID">
                <el-select
                  v-model="form.ORMTB410ID"
                  :validate-event="false"
                  filterable
                  remote
                  clearable
                  :remote-method="filterFormCustomer"
                  placeholder="请选择用户"
                  @change="handleCustomerChange">
                  <el-option
                    v-for="item in formCustomerOptions"
                    :key="item.ORMTB410ID"
                    :label="item.ORMTB410CA00"
                    :value="item.ORMTB410ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设置类型" prop="settingType">
                <el-select v-model="form.settingType" :validate-event="false" placeholder="请选择设置类型">
                  <el-option
                    v-for="item in settingTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="setting-block" v-if="showFreezeSetting">
          <div class="setting-block-title">下单冻结设置</div>
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="保底冻结" prop="ORMTB410CB41">
                <el-input-number
                  v-model="form.ORMTB410CB41"
                  :validate-event="false"
                  :controls="false"
                  :precision="2"
                  @change="clearFormFieldValidate('ORMTB410CB41')"></el-input-number>
                <span class="form-unit">元</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="冻结倍数" prop="ORMTB410CB07">
                <el-input-number
                  v-model="form.ORMTB410CB07"
                  :validate-event="false"
                  :controls="false"
                  :precision="1"
                  @change="clearFormFieldValidate('ORMTB410CB07')"></el-input-number>
                <span class="form-unit">倍</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="setting-block" v-if="showOilCardSetting">
          <div class="setting-block-title">油卡比例</div>
          <el-form-item label="油卡比例" prop="ORMTB410CB17">
            <el-input-number
              v-model="form.ORMTB410CB17"
              :validate-event="false"
              :controls="false"
              :precision="2"
              @change="clearFormFieldValidate('ORMTB410CB17')"></el-input-number>
            <span class="form-unit">%</span>
          </el-form-item>
        </div>

        <div class="setting-block" v-if="showFactorySetting">
          <div class="setting-block-title">授权厂家</div>
          <el-form-item label="厂家列表">
            <div class="factory-box" v-loading="factoryLoading">
              <el-checkbox
                v-model="checkAllFactory"
                :indeterminate="isIndeterminateFactory"
                @change="handleCheckAllFactory">
                全选
              </el-checkbox>
              <el-checkbox-group v-model="checkedFactoryNames" @change="handleFactoryChange">
                <el-checkbox
                  v-for="item in factoryList"
                  :key="item.SETTB99ID"
                  :label="item.SETTB99CA00">
                  {{ item.SETTB99CA00 }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer setting-dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitSetting">提交设置</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="detailDialogTitle"
      :visible.sync="detailVisible"
      width="760px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="big-customer-setting-dialog">
      <div class="setting-current">
        <div class="setting-current-meta">
          <div class="setting-current-head">{{ detailSetting.ORMTB410CA00 || '-' }}</div>
          <div class="setting-current-type">{{ formatSettingType(detailSetting.settingType) }}</div>
        </div>
        <div class="setting-current-grid">
          <div class="setting-current-item" v-if="detailSetting.ORMTB410DJ04">
            <span>保底冻结</span>
            <strong>{{ detailSetting.ORMTB410DJ04}}</strong>
          </div>
          <div class="setting-current-item" v-if="detailSetting.ORMTB410DJ02">
            <span>冻结倍数</span>
            <strong>{{ detailSetting.ORMTB410DJ02 }}</strong>
          </div>
          <div class="setting-current-item" v-if="detailSetting.ORMTB410DJ09">
            <span>油卡比例</span>
            <strong>{{ detailSetting.ORMTB410DJ09}}</strong>%
          </div>
          <div class="setting-current-item setting-current-item-wide" v-if="detailSetting.ORMTB410DJ11">
            <span>授权厂家</span>
            <div class="setting-current-factory-list">
              <span
                class="setting-current-factory-tag"
                v-for="(factory, index) in getFactoryList(detailSetting.ORMTB410DJ11)"
                :key="factory + '-detail-' + index">
                {{ factory }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="currentSettingDialogTitle"
      :visible.sync="currentSettingVisible"
      width="760px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="big-customer-setting-dialog">
      <div class="setting-current" v-loading="currentSettingLoading">
        <div class="setting-current-meta">
          <div class="setting-current-head">{{ currentSetting.ORMTB410CA00 || '-' }}</div>
          <div class="setting-current-type">{{ formatSettingType(currentSetting.settingType) }}</div>
        </div>
        <div class="setting-current-grid">
          <div class="setting-current-item" v-if="currentSetting.ORMTB410CB41">
            <span>保底冻结</span>
            <strong>{{currentSetting.ORMTB410CB41 }}</strong>
          </div>
          <div class="setting-current-item" v-if="currentSetting.ORMTB410CB07">
            <span>冻结倍数</span>
            <strong>{{ currentSetting.ORMTB410CB07 }}</strong>
          </div>
          <div class="setting-current-item" v-if="currentSetting.ORMTB410CB17 || currentSetting.ORMTB410CB17==0">
            <span>油卡比例</span>
            <strong>{{ currentSetting.ORMTB410CB17 }}</strong>%
          </div>
          <div class="setting-current-item setting-current-item-wide" v-if="currentSetting.ORMTB706CA04">
            <span>授权厂家</span>
            <div class="setting-current-factory-list">
              <span
                class="setting-current-factory-tag"
                v-for="(factory, index) in getFactoryList(currentSetting.ORMTB706CA04)"
                :key="factory + '-' + index">
                {{ factory }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uobj: this.$store.state.uobj,
      customerOptions: [],
      queryCustomerOptions: [],
      formCustomerOptions: [],
      query: {
        ORMTB410ID: '',
        userName: '',
        settingType: ''
      },
      settingTypeOptions: [
        { label: '下单冻结设置', value: 'FREEZE' },
        { label: '油卡比例', value: 'OIL_CARD_RATIO' },
        { label: '授权厂家', value: 'AUTH_FACTORY' }
      ],
      tableData: [],
      tableLoading: false,
      page: 1,
      limit: 10,
      total: 0,
      dialogVisible: false,
      currentSettingVisible: false,
      currentSettingDialogTitle: '查看当前设置',
      currentSettingLoading: false,
      detailVisible: false,
      detailDialogTitle: '详情',
      detailSetting: {},
      submitLoading: false,
      factoryLoading: false,
      currentSetting: {},
      form: this.getEmptyForm(),
      rules: {
        ORMTB410ID: [{ required: true, message: '请选择用户' }],
        settingType: [{ required: true, message: '请选择设置类型' }],
        ORMTB410CB41: [
          { required: true, message: '请输入保底冻结' },
          { validator: this.validateFreezeAmount }
        ],
        ORMTB410CB07: [
          { required: true, message: '请输入冻结倍数' },
          { validator: this.validateFreezeMultiple }
        ],
        ORMTB410CB17: [
          { required: true, message: '请输入油卡比例' },
          { validator: this.validateOilCardRatio }
        ]
      },
      factoryList: [],
      checkedFactoryNames: [],
      checkedFactoryIds: [],
      checkAllFactory: false,
      isIndeterminateFactory: false,
      solelist: [],
    }
  },
  created() {
    this.loadCustomers()
    this.queryRecords()
    var list = this.$store.state.solelist || []
    var path = this.$route.path
    if (path === '/salesBigCustomerSetting') {
      path = '/Home' + path
    }
    this.solelist = this.$baseAPI.querSoleList(list, path) || [] //获取权限列表
  },
  activated() {
    this.queryRecords()
  },
  computed: {
    showFreezeSetting() {
      return this.form.settingType === 'FREEZE'
    },
    showOilCardSetting() {
      return this.form.settingType === 'OIL_CARD_RATIO'
    },
    showFactorySetting() {
      return this.form.settingType === 'AUTH_FACTORY'
    },
    showCurrentFreezeSetting() {
      return this.currentSetting.settingType === 'FREEZE' ||
        (!this.currentSetting.settingType &&
          (this.currentSetting.ORMTB410CB41 !== undefined ||
            this.currentSetting.ORMTB410CB07 !== undefined))
    },
    showCurrentOilCardSetting() {
      return this.currentSetting.settingType === 'OIL_CARD_RATIO' ||
        (!this.currentSetting.settingType &&
          this.currentSetting.ORMTB410CB17 !== undefined &&
          this.currentSetting.ORMTB410CB17 !== null &&
          this.currentSetting.ORMTB410CB17 !== '')
    },
    showCurrentFactorySetting() {
      return this.currentSetting.settingType === 'AUTH_FACTORY' ||
        (!this.currentSetting.settingType && !!this.currentSetting.ORMTB706CA04)
    }
  },
  methods: {
    getEmptyForm() {
      return {
        ORMTB410ID: '',
        ORMTB410CA00: '',
        settingType: 'FREEZE',
        ORMTB410CB41: undefined,
        ORMTB410CB07: undefined,
        ORMTB410CB17: undefined
      }
    },
    getOrmTb400Id() {
      return this.uobj && this.uobj.ormtb400 ? this.uobj.ormtb400.ORMTB400ID : ''
    },
    validateFreezeAmount(rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        callback()
        return
      }
      if (Number(value) <= 0) {
        callback(new Error('保底冻结必须大于0'))
        return
      }
      callback()
    },
    validateFreezeMultiple(rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        callback()
        return
      }
      if (Number(value) <= 0) {
        callback(new Error('冻结倍数必须大于0'))
        return
      }
      callback()
    },
    validateOilCardRatio(rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        callback()
        return
      }
      if (Number(value) < 0) {
        callback(new Error('油卡比例不能小于0'))
        return
      }
      callback()
    },
    loadCustomers() {
      var postData = { ORMTB400ID: this.getOrmTb400Id() }
      this.axios.post('/orm/ormtb410/selectOrmtb410s', postData).then(res => {
        if (res.data.code == 200) {
          this.customerOptions = res.data.data || []
          this.queryCustomerOptions = this.customerOptions.slice(0, 100)
          this.formCustomerOptions = this.customerOptions.slice(0, 100)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    filterCustomer(query) {
      if (!query) {
        this.queryCustomerOptions = this.customerOptions.slice(0, 100)
        return
      }
      var q = query.toLowerCase()
      this.queryCustomerOptions = this.customerOptions.filter(item =>
        (item.ORMTB410CA00 || '').toLowerCase().includes(q) ||
        (item.ORMTB410CA13 || '').toLowerCase().includes(q) ||
        (item.ORMTB410CA02 || '').includes(query)
      )
    },
    filterFormCustomer(query) {
      if (!query) {
        this.formCustomerOptions = this.customerOptions.slice(0, 100)
        return
      }
      var q = query.toLowerCase()
      this.formCustomerOptions = this.customerOptions.filter(item =>
        (item.ORMTB410CA00 || '').toLowerCase().includes(q) ||
        (item.ORMTB410CA13 || '').toLowerCase().includes(q) ||
        (item.ORMTB410CA02 || '').includes(query)
      )
    },
    handleSearch() {
      this.page = 1
      this.queryRecords()
    },
    queryRecords() {
      this.page = this.page || 1
      this.tableLoading = true
      var postData = {
        ORMTB410ID: this.query.ORMTB410ID,
        ORMTB410DJ08: this.getSettingTypeCode(this.query.settingType),
        page: this.page,
        limit: this.limit
      }
      this.axios.post('/orm/ormtb410Set/queryList', postData).then(res => {
        if (res.data.code == 200) {
          this.tableData = (res.data.data || []).map(this.normalizeRecord)
          this.total = res.data.count || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error(res.data.message)
        }
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).then(() => {
        this.tableLoading = false
      })
    },
    normalizeRecord(row) {
      var record = Object.assign({}, row || {})
      record.settingType = this.getSettingTypeByCode(record.ORMTB410DJ08)
      record.createTime = record.ORMTB410DJ05
      record.createName = record.ORMTB410DJ06
      record.ORMTB410CB41 = record.ORMTB410DJ04
      record.ORMTB410CB07 = record.ORMTB410DJ02
      record.ORMTB410CB17 = record.ORMTB410DJ09
      record.ORMTB706CA04 = record.ORMTB410DJ11
      return record
    },
    handleQueryCustomerChange(customerId) {
      if (!customerId) {
        this.query.userName = ''
        this.queryCustomerOptions = this.customerOptions.slice(0, 100)
        return
      }
      var customer = this.customerOptions.find(item => item.ORMTB410ID === customerId) || {}
      this.query.userName = customer.ORMTB410CA00 || ''
    },
    resetQuery() {
      this.query.ORMTB410ID = ''
      this.query.userName = ''
      this.query.settingType = ''
      this.queryCustomerOptions = this.customerOptions.slice(0, 100)
      this.page = 1
      this.queryRecords()
    },
    viewSelectedUserSetting() {
      if (!this.query.ORMTB410ID) {
        this.$message.warning('请先选择用户名')
        return
      }
      var customer = this.customerOptions.find(item => item.ORMTB410ID === this.query.ORMTB410ID) || {
        ORMTB410ID: this.query.ORMTB410ID,
        ORMTB410CA00: this.query.userName
      }
      this.currentSettingDialogTitle = '查看' + (customer.ORMTB410CA00 || this.query.userName || '用户名') + '当前设置'
      this.currentSettingVisible = true
      this.currentSettingLoading = true
      this.currentSetting = {
        ORMTB410ID: customer.ORMTB410ID,
        ORMTB410CA00: customer.ORMTB410CA00,
        settingType: this.query.settingType
      }
      this.axios.post('/orm/ormtb410Set/queryCurrentSet', {
        ORMTB410ID: customer.ORMTB410ID
      }).then(res => {
        if (res.data.code == 200) {
          this.currentSetting = res.data.data;
        } else {
          this.$message.warning(res.data.message || '未获取到当前设置')
        }
      }).catch(() => {}).then(() => {
        this.currentSettingLoading = false
      })
    },
    openSettingPanel() {
      this.form = this.getEmptyForm()
      this.formCustomerOptions = this.customerOptions.slice(0, 100)
      this.factoryList = []
      this.checkedFactoryNames = []
      this.checkedFactoryIds = []
      this.checkAllFactory = false
      this.isIndeterminateFactory = false
      this.dialogVisible = true
      this.loadAllFactoryList()
      this.$nextTick(() => {
        if (this.$refs.settingForm) this.$refs.settingForm.clearValidate()
      })
    },
    clearFormFieldValidate(field) {
      this.$nextTick(() => {
        if (this.$refs.settingForm) this.$refs.settingForm.clearValidate([field])
      })
    },
    handleCustomerChange(customerId) {
      if (!customerId) {
        this.form.ORMTB410CA00 = ''
        this.formCustomerOptions = this.customerOptions.slice(0, 100)
        this.$nextTick(() => {
          if (this.$refs.settingForm) this.$refs.settingForm.clearValidate(['ORMTB410ID'])
        })
        return
      }
      var customer = this.customerOptions.find(item => item.ORMTB410ID === customerId) || {}
      this.form.ORMTB410CA00 = customer.ORMTB410CA00 || ''
      this.$nextTick(() => {
        if (this.$refs.settingForm) this.$refs.settingForm.clearValidate(['ORMTB410ID'])
      })
      // this.form.ORMTB410CB41 = undefined
      // this.form.ORMTB410CB07 = undefined
      // this.form.ORMTB410CB17 = undefined
      // this.loadFactoryList(customerId)
      // this.$nextTick(() => {
      //   this.clearFormFieldValidate('ORMTB410CB41')
      //   this.clearFormFieldValidate('ORMTB410CB07')
      //   this.clearFormFieldValidate('ORMTB410CB17')
      // })
    },
    loadFactoryList(customerId) {
      this.factoryLoading = true
      this.factoryList = []
      this.checkedFactoryNames = []
      this.checkedFactoryIds = []
      this.checkAllFactory = false
      this.isIndeterminateFactory = false
      if (!customerId) {
        this.loadAllFactoryList()
        return
      }
      this.axios.post('orm/ormtb706/selectSettb100ByCa02V2', { ORMTB706CA00: customerId }).then(res => {
        if (res.data.code == 200) {
          this.factoryList = res.data.data || []
          this.checkedFactoryNames = this.factoryList.filter(item => item.check == 1).map(item => item.SETTB99CA00)
          this.checkedFactoryIds = this.factoryList.filter(item => item.check == 1).map(item => item.SETTB99ID)
          this.syncFactoryCheckState()
          if (this.factoryList.length === 0) this.loadAllFactoryList()
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(() => {}).then(() => {
        this.factoryLoading = false
      })
    },
    loadAllFactoryList() {
      this.factoryLoading = true
      var postData = {
        ORMTB400ID: this.getOrmTb400Id(),
        type: 1
      }
      this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
        if (res.data.code == 200) {
          this.factoryList = res.data.data || []
          this.syncFactoryCheckState()
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(() => {}).then(() => {
        this.factoryLoading = false
      })
    },
    handleFactoryChange(value) {
      this.checkedFactoryIds = this.factoryList.filter(item => value.includes(item.SETTB99CA00)).map(item => item.SETTB99ID)
      this.syncFactoryCheckState()
    },
    handleCheckAllFactory(val) {
      this.checkedFactoryNames = val ? this.factoryList.map(item => item.SETTB99CA00) : []
      this.checkedFactoryIds = val ? this.factoryList.map(item => item.SETTB99ID) : []
      this.syncFactoryCheckState()
    },
    syncFactoryCheckState() {
      var checkedCount = this.checkedFactoryNames.length
      this.checkAllFactory = checkedCount > 0 && checkedCount === this.factoryList.length
      this.isIndeterminateFactory = checkedCount > 0 && checkedCount < this.factoryList.length
    },
    getSettingTypeCode(settingType) {
      var settingTypeMap = {
        FREEZE: '1',
        OIL_CARD_RATIO: '2',
        AUTH_FACTORY: '3'
      }
      return settingTypeMap[settingType] || ''
    },
    getSettingTypeByCode(code) {
      var settingTypeMap = {
        '1': 'FREEZE',
        '2': 'OIL_CARD_RATIO',
        '3': 'AUTH_FACTORY'
      }
      return settingTypeMap[String(code)] || ''
    },
    submitSetting() {
      this.$refs.settingForm.validate(valid => {
        if (!valid) return
        if (!this.validateSettingByType()) return
        this.submitLoading = true
        var postData = {
          ORMTB410ID: this.form.ORMTB410ID,
          ORMTB410CA00: this.form.ORMTB410CA00,
          ORMTB410DJ08: this.getSettingTypeCode(this.form.settingType)
        }
        if (this.form.settingType === 'FREEZE') {
          postData.ORMTB410CB07 = String(this.form.ORMTB410CB07)
          postData.ORMTB410CB41 = String(this.form.ORMTB410CB41)
        }
        if (this.form.settingType === 'OIL_CARD_RATIO') {
          postData.ORMTB410CB17 = String(this.form.ORMTB410CB17)
        }
        if (this.form.settingType === 'AUTH_FACTORY') {
          postData.ORMTB410DJ10 = this.checkedFactoryIds.join(',')
          postData.ORMTB410DJ11 = this.checkedFactoryNames.join(',')
        }
        this.axios.post('/orm/ormtb410Set/insertSet', postData).then(res => {
          if (res.data.code == 200) {
            this.$message.success('设置成功')
            this.dialogVisible = false
            this.query.userName = this.form.ORMTB410CA00
            this.page = 1
            this.queryRecords()
          } else {
            this.$message.error(res.data.message)
          }
        }).catch(() => {}).then(() => {
          this.submitLoading = false
        })
      })
    },
    validateSettingByType() {
      if (this.form.settingType === 'FREEZE') {
        if (this.form.ORMTB410CB41 === undefined || this.form.ORMTB410CB41 === null || this.form.ORMTB410CB41 === '') {
          this.$message.warning('请输入保底冻结')
          return false
        }
        if (this.form.ORMTB410CB07 === undefined || this.form.ORMTB410CB07 === null || this.form.ORMTB410CB07 === '') {
          this.$message.warning('请输入冻结倍数')
          return false
        }
      }
      if (this.form.settingType === 'OIL_CARD_RATIO') {
        if (this.form.ORMTB410CB17 === undefined || this.form.ORMTB410CB17 === null || this.form.ORMTB410CB17 === '') {
          this.$message.warning('请输入油卡比例')
          return false
        }
      }
      return true
    },
    viewDetailSetting(row, title) {
      this.detailDialogTitle = title || '详情'
      this.detailVisible = true
      this.detailSetting = this.normalizeRecord(Object.assign({}, row || {}))
    },
    handleSizeChange(val) {
      this.limit = val
      this.page = 1
      this.queryRecords()
    },
    handleCurrentChange(val) {
      this.page = val
      this.queryRecords()
    },
    hasValue(value) {
      return value !== undefined && value !== null && String(value).trim() !== ''
    },
    getFactoryList(value) {
      if (!this.hasValue(value)) return []
      if (Array.isArray(value)) return value.filter(item => this.hasValue(item))
      return String(value)
        .split(/[，,、；;\s]+/)
        .map(item => item.trim())
        .filter(item => this.hasValue(item))
    },
    formatPercent(value) {
      if (value === undefined || value === null || value === '') return ''
      return value + '%'
    },
    formatSettingType(value) {
      var item = this.settingTypeOptions.find(option => option.value === value)
      return item ? item.label : (value || '')
    },
    formatEmpty(value) {
      if (value === undefined || value === null || value === '') return '-'
      return value
    }
  }
}
</script>

<style scoped>
.big-customer-setting {
  min-height: 100%;
  padding: 16px;
  box-sizing: border-box;
  background: #f5f8fc;
}

.setting-panel {
  padding: 18px 20px;
  margin-bottom: 14px;
  border: 1px solid #e1edf7;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(28, 83, 126, .06);
}

.setting-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.setting-section-title {
  padding-left: 12px;
  border-left: 4px solid #1aa0ff;
  color: #1f3854;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.setting-section-desc {
  margin: 8px 0 14px 16px;
  color: #6f8094;
  font-size: 13px;
  line-height: 20px;
}

.setting-filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 14px;
}

.setting-action-tip {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.setting-inline-tip {
  color: #6f8094;
  font-size: 13px;
  line-height: 20px;
  white-space: nowrap;
}

.setting-filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.setting-filter-item label {
  color: #52616f;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
}

.setting-filter-item .el-input,
.setting-filter-item .el-select {
  width: 260px;
}

.setting-filter-item /deep/ .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.setting-filter-item /deep/ .el-input__suffix-inner {
  display: flex;
  align-items: center;
  height: 100%;
}

.setting-filter-item /deep/ .el-input__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 100%;
  line-height: 1;
}

.setting-filter-item /deep/ .el-input__suffix-inner .el-input__icon + .el-input__icon {
  margin-left: 4px;
}

.setting-table-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.setting-record-table {
  width: 100%;
}

.setting-pagination {
  margin-top: 14px;
  text-align: right;
}

.setting-block {
  padding: 14px 14px 2px;
  margin-bottom: 14px;
  border: 1px solid #e1edf7;
  border-radius: 10px;
  background: #f8fbff;
}

.setting-block-title {
  margin-bottom: 12px;
  color: #1f3854;
  font-size: 15px;
  font-weight: 700;
}

.form-unit {
  margin-left: 8px;
  color: #60758a;
  font-weight: 700;
}

.factory-box {
  min-height: 120px;
  max-height: 260px;
  padding: 12px;
  overflow-y: auto;
  border: 1px solid #dfe8f4;
  border-radius: 8px;
  background: #fff;
}

.factory-box /deep/ .el-checkbox {
  min-width: 180px;
  margin: 6px 18px 6px 0;
}

.setting-current-head {
  color: #1f3854;
  font-size: 18px;
  font-weight: 700;
}

.setting-current-meta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.setting-current-type {
  color: #60758a;
  font-size: 14px;
  font-weight: 600;
}

.setting-current-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.setting-current-item {
  padding: 14px 16px;
  border: 1px solid #e1edf7;
  border-radius: 10px;
  background: #f8fbff;
}

.setting-current-item span {
  display: block;
  margin-bottom: 8px;
  color: #6f8094;
  font-size: 13px;
}

.setting-current-item strong {
  color: #1f3854;
  font-size: 15px;
  word-break: break-all;
}

.setting-current-factory-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.setting-current-factory-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  background: #eef6ff;
  border: 1px solid #d7e9fb;
  color: #1f3854;
  font-size: 14px;
  max-width: 100%;
  word-break: break-all;
  line-height: 32px;
}


.setting-current-item-wide {
  grid-column: 1 / -1;
}

.big-customer-setting /deep/ .el-input-number,
.big-customer-setting /deep/ .el-select {
  width: 100%;
}

.setting-record-table /deep/ .el-table__body td .cell,
.setting-record-table /deep/ .el-table__header th .cell {
  text-align: center;
}

@media screen and (max-width: 900px) {
  .setting-hero {
    display: block;
  }

  .setting-filter-item,
  .setting-filter-item .el-input,
  .setting-filter-item .el-select {
    width: 100%;
  }
}
</style>

<style>
.big-customer-setting-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.big-customer-setting-dialog .el-dialog__header {
  padding: 18px 54px 15px 24px;
  background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  border-bottom: 1px solid #dcecf8;
}

.big-customer-setting-dialog .el-dialog__title {
  color: #102033;
  font-size: 18px;
  font-weight: 700;
}

.setting-dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}

.setting-dialog-footer .el-button + .el-button {
  margin-left: 0;
}
</style>
